module.exports = "<div class=\"pamplemousse\">\n    <div class=\"pamplemousse__pip\"><i></i></div>\n    <div class=\"pamplemousse__pip\"><i></i></div>\n    <div class=\"pamplemousse__pip\"><i></i></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/common/views/ui/loading.html
// module id = 199
// module chunks = 1 5 18